export default __webpack_public_path__ + "static/media/icn-empty-state.3a230abd.svg";